import React from 'react'
import 'twin.macro'
import { AiFillCaretUp, AiFillCaretDown } from 'react-icons/ai'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '@api/index'

interface Props {
  eventId: number
  currentPageIdx: number
}

const EventPriorityChangeButton = ({ eventId, currentPageIdx }: Props) => {
  const queryClient = useQueryClient()
  const changePriorityMutation = useMutation(
    (command: 0 | 1) => api.adminService.changeEventPriority(eventId, command),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['EventList', currentPageIdx])
      },
    }
  )

  const handleClickButton = (command: 0 | 1) => {
    changePriorityMutation.mutate(command)
  }

  return (
    <div tw="flex gap-15 all:text-30 justify-center">
      <button>
        <AiFillCaretUp
          onClick={(e) => {
            handleClickButton(1)
            e.stopPropagation()
          }}
          tw="text-gray-600 hover:text-blue-500"
        />
      </button>
      <button>
        <AiFillCaretDown
          onClick={(e) => {
            handleClickButton(0)
            e.stopPropagation()
          }}
          tw="hover:text-blue-500"
        />
      </button>
    </div>
  )
}

export default EventPriorityChangeButton
